import { render, staticRenderFns } from "./pintura_photo_uploader.vue?vue&type=template&id=44218dc7&"
import script from "./pintura_photo_uploader.vue?vue&type=script&lang=js&"
export * from "./pintura_photo_uploader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports